import { normalizeDocumentNumber } from '../../services/documents';

/**
 * Transforms the stored blacklist item in the redux store
 * into a suitable representation to send to API.
 * Caveats:
 * - Blacklist Update API expects a personalId object
 * - Blacklist Create API expects idType and idNumber fields
 * - idCountry (ISO del país del documento) lo guarda crowd solo con el flag
 *   visitors.country.enabled; sin flag lo ignora.
 */
export function serialize(storedBlacklist) {
  const blacklist = {
    idType: storedBlacklist.idType,
    idNumber: normalizeDocumentNumber(storedBlacklist.idNumber),
    idCountry: storedBlacklist.idCountry || null,
    type: storedBlacklist.type,
    creationDate: storedBlacklist.creationDate,
    reason: storedBlacklist.reason
  };
  if (storedBlacklist.visitor != null) {
    blacklist.name = storedBlacklist.visitor.name;
  } else if (storedBlacklist.name != null) {
    blacklist.name = storedBlacklist.name;
  }
  if (storedBlacklist.id != null) {
    blacklist.id = storedBlacklist.id;
  }
  return blacklist;
}

/**
 * Bloqueos activos que coinciden en tipo y número (la búsqueda de crowd por
 * número puede traer parecidos). Si los dos tienen país, también tiene que
 * coincidir; los bloqueos viejos sin país se comparan solo por tipo y número.
 */
export const matchBlacklist = (items, idType, idNumber, idCountry) => {
  const number = normalizeDocumentNumber(idNumber);
  return (items || []).filter(
    item =>
      item.status !== 'DELETED' &&
      item.idType === idType &&
      normalizeDocumentNumber(item.idNumber) === number &&
      (!idCountry || !item.idCountry || item.idCountry === idCountry)
  );
};
